import { render, staticRenderFns } from "./transporter-data.vue?vue&type=template&id=348e455c"
import script from "./transporter-data.vue?vue&type=script&lang=js"
export * from "./transporter-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports